<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1050px"
      :title="'删除日志（'+DeviceName+'）'"
      :save-func="()=>{}"
      :confirm-on-close-change="false"
      @create-opened="onCreateOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="filter-container">
          <el-row class="filter-top" type="flex" justify="end">
            <el-col :span="isMB?11:16">
              <span class="span-top-text" style="line-height:39px;">查询条件</span>
              <div class="searchIcon" @click="showForm = !showForm">
                <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </div>
            </el-col>
            <el-col :span="isMB?13:8">
              <div class="btn-search">
                <el-button type="primary" icon="el-icon-search" @click="onQuery()">搜索</el-button>
                <el-button type="primary" plain @click="resetQuery">重置</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row v-show="showForm">
            <el-divider style="margin:0px;"></el-divider>
            <el-form label-width="85px" class="form-item" :class="{'form-item-left':isMB}">
              <el-form-item label="人员编号">
                <el-input v-model="params.MemberNo" placeholder="请输入人员编号" />
              </el-form-item>
              <el-form-item label="人员姓名">
                <el-input v-model="params.MemberName" placeholder="请输入人员姓名" />
              </el-form-item>
              <el-form-item label="人员类型">
                <el-select v-model="params.MemberType" placeholder="请选择人员类型" clearable>
                  <el-option label="学生" :value="0"></el-option>
                  <el-option label="教职人员" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年级">
                <el-select v-model="params.CurrentGradeId" placeholder="请选择年级" clearable>
                  <el-option label="高一" :value="1"></el-option>
                  <el-option label="高二" :value="2"></el-option>
                  <el-option label="高三" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级">
                <el-select v-model="params.CurrentClassId" placeholder="请选择班级" clearable>
                  <template v-for="(i,key) in class_list">
                    <el-option :key="key" :label="i.ClassName" :value="i.ClassId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="部门">
                <tree-select
                  ref="treeSelect"
                  parent-select
                  :props="dpProps"
                  :options="dp_list"
                  @node-select="(x)=>{params.DpIdChain=x?x.IdChain:null}"
                />
              </el-form-item>
              <el-form-item label="执行状态">
                <el-select v-model="params.SendStatus" placeholder="请选择执行状态" clearable>
                  <!-- 待执行/执行中/执行完成/执行失败 -->
                  <el-option label="待执行" :value="0"></el-option>
                  <el-option label="执行中" :value="1"></el-option>
                  <el-option label="执行完成" :value="2"></el-option>
                  <el-option label="执行失败" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
        <div ref="tbcontent">
          <div class="row-head">
            <span>人员列表</span>
            <div style="float: right;">
              <el-button type="primary" plain @click="onRerelease">重新执行</el-button>
              <el-button type="primary" @click="onCreate" icon="el-icon-plus">添加</el-button>
              <!-- <el-button type="danger" @click="onDelete">删除</el-button> -->
            </div>
          </div>
          <el-table
            v-loading="tbLoading"
            :data="data"
            border
            :row-class-name="rowClass"
            @selection-change="onSelect"
          >
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column prop="MemberNo" label="人员编号" width="90px">
              <template slot-scope="{row}">
                <span v-if="row.MemberType==0">{{row.StudentNumber}}</span>
                <span v-else>{{row.TeacherNumber}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="MemberName" label="人员姓名" width="90px">
              <template slot-scope="{row}">
                <span v-if="row.MemberType==0">{{row.StudentName}}</span>
                <span v-else>{{row.TeacherName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="CurrentGrade" label="年级" width="70px" />
            <el-table-column prop="CurrentClass" label="班级" width="70px" />
            <el-table-column prop="DpNames" label="部门" width="140px" />
            <el-table-column prop="MemberType" label="人员类型" width="80px">
              <template slot-scope="{row}">
                <span v-if="row.MemberType==0">学生</span>
                <span v-else>教职人员</span>
              </template>
            </el-table-column>
            <el-table-column prop="SendStatus" label="执行状态" min-width="210px">
              <template slot-scope="{row}">
                <!-- 待执行/执行中/执行完成/执行失败 -->
                <el-tag type="info" v-if="row.SendStatus == 0">待执行</el-tag>
                <el-tag type="primary" v-if="row.SendStatus == 1">执行中</el-tag>
                <el-tag type="success" v-if="row.SendStatus == 2">执行完成</el-tag>
                <template v-if="row.SendStatus == 3">
                  <el-tag type="danger">执行失败</el-tag>
                  <span style="margin-left: 10px;">{{row.SendMsg}}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="SendTime" label="执行时间" width="140px" />
          </el-table>
          <div style="height: 10px;"></div>
          <el-pagination
            :page-size.sync="params.PageSize"
            :current-page.sync="params.PageIndex"
            :page-sizes="[15,30,50,100,300]"
            layout="total, sizes, prev, pager, next"
            :total="total"
            @size-change="getData"
            @current-change="getData"
          />
        </div>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
      <member-dialog ref="memberDialog" @select-multiple="setMember" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import memberDialog from "./memberDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
    memberDialog,
  },
  data() {
    return {
      data: [],
      params: {
        MemberName: "",
        MemberNo: "",
        MemberType: null,
        DpIdChain: "",
        CurrentGradeId: null,
        CurrentClassId: null,
        SendStatus: null, //待下发/下发中/下发完成/下发失败
        SendLogType: 1,
        DeviceId: 0,
        PageSize: 10,
        PageIndex: 1,
      },
      selectRows: [],
      DeviceName: "",
      total: 0,
      tbLoading: false,
      isMB: this.$store.state.isMB,
      showForm: !this.$store.state.isMB,
      api: require("@/api/cp/sendlog").default,
      class_api: require("@/api/ed/class").default,
      grade_api: require("@/api/ed/grade").default,
      dp_api: require("@/api/ent/dp").default,
      class_list: [],
      grade_list: [],
      dp_list: [],
      dpProps: {
        // 配置项（必选）
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      // tbHeight: 0,
      // tbContent: 0,
    };
  },
  // computed: {
  //   tbcontent() {
  //     if (this.showForm) return "height: calc(100% - 156px);";
  //     else return "height: calc(100% - 102px);";
  //   },
  // },
  watch: {
    // showForm() {
    //   console.log("height", this.$refs.tbcontent.clientHeight);
    //   this.tbHeight = this.$refs.tbcontent.clientHeight - 41;
    // },
    "params.CurrentGradeId": {
      handler() {
        this.params.CurrentClassId = null;
        if (this.params.CurrentGradeId) {
          var info = JSON.parse(localStorage.getItem("loginInfo"));
          var params = {
            TermId: info.TermId,
            GradeId: this.params.CurrentGradeId,
          };
          this.class_api.list(params).then((res) => {
            this.class_list = res.Data;
          });
        } else {
          this.class_list = [];
        }
      },
    },
  },
  methods: {
    onCreateOpened(data) {
      console.log("data", JSON.parse(JSON.stringify(data)));

      this.params.DeviceId = data.DeviceId;
      this.DeviceName = data.DeviceName;
      // console.log("tbcontent", this.$refs.tbcontent.clientHeight);
      // this.tbHeight = this.$refs.tbcontent.clientHeight - 41;

      // this.grade_api.list({}).then((res) => {});
      this.dp_api.list({}).then((res) => {
        this.dp_list = this.$commonJs.toTreeData(res.Data, "DpId");
      });
      this.getData();
    },
    getData() {
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.tbLoading = true;
      this.api.list(params).then((res) => {
        this.tbLoading = false;
        this.total = res.Count;
        this.data = res.Data;
      });
    },
    onQuery() {
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.getData();
    },
    resetQuery() {
      this.params.MemberName = "";
      this.params.MemberNo = "";
      this.params.MemberType = null;
      this.params.DpIdChain = "";
      this.params.CurrentGradeId = null;
      this.params.CurrentClassId = null;
      this.params.SendStatus = null;
      this.$refs.treeSelect.clearHandle();
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.getData();
    },
    rowClass({ row, rowIndex }) {
      if (row.Checked) return "select-row";
      return "";
    },
    onSelect(rows) {
      this.selectRows = rows;
    },
    onRerelease() {
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择要重新下发的数据");
        return;
      }
      this.$confirm("确认重新下发数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var save_list = this.selectRows.map((x) => {
            return {
              DeviceId: x.DeviceId,
              MemberType: x.MemberType,
              MemberId: x.MemberId,
              SendLogType: 1,
            };
          });
          var loading = this.$loading({
            lock: true,
            text: "正在重新下发...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          console.log("重新下发", JSON.parse(JSON.stringify(save_list)));
          this.api.saveList(save_list).then((res) => {
            loading.close();
            if (res.Code == 0) {
              this.$message.success("重新下发成功");
              this.selectRows = [];
              this.resetQuery();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    onCreate() {
      this.$refs.memberDialog.open().then((that) => {
        that.init([], null, true);
      });
    },
    setMember(data) {
      console.log("setMember", JSON.parse(JSON.stringify(data)));
      // this.data = [];
      // data.forEach((x) => this.data.push({ ...x }));
      var save_list = [];
      data.forEach((x) => {
        save_list.push({
          DeviceId: this.params.DeviceId,
          MemberType: x.MemberType,
          MemberId: x.MemberId,
          SendLogType: 1,
        });
      });
      console.log("保存", JSON.parse(JSON.stringify(save_list)));
      this.$refs.dialog.isLoading = true;
      this.api.saveList(save_list).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success("保存成功");
          this.getData();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onDelete() {
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      var ids = this.selectRows.map((x) => x.SendLogId);
      this.api.delete({ ids: ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.getData();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.params.MemberName = "";
      this.params.MemberNo = "";
      this.params.MemberType = null;
      this.params.DpIdChain = "";
      this.params.CurrentGradeId = null;
      this.params.CurrentClassId = null;
      this.params.SendStatus = null;
      this.$refs.treeSelect.clearHandle();
      this.params.PageIndex = 1;
      this.params.PageSize = 10;
      this.data = [];
      this.selectRows = [];
    },
  },
};
</script>
<style lang="scss">
.select-row {
  background-color: #f0f9eb !important;
}
</style>